document.addEventListener("DOMContentLoaded", (event) => {
  const formShipping = document.getElementById("shipping-calculator-form");
  const formResults = document.getElementById("shipping-calculator-results");
  const formErrors = document.getElementById("shipping-calculator-errors");
  const errorMessage = document.getElementById("error-message");
 

  formShipping.addEventListener("submit", async function (event) {
    event.preventDefault();

    // Mostrar estado de carga
    formShipping.classList.add("pending");

    // Obtener datos del formulario
    const formData = new FormData(formShipping);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.origin}/cart/shipping_rates.json?${searchParams}`;

    try {
      // Realizar la solicitud
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Accept": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const data = await response.json();

      // Mostrar resultados
      if (data.shipping_rates && data.shipping_rates.length > 0) {

        console.log(data);
        
        const resultsHTML = data.shipping_rates.map(rate => {
          return `<li>${rate.name}: ${rate.price}</li>`;
        }).join("");

        formResults.querySelector("ul").innerHTML = resultsHTML;
        formResults.querySelector("p").textContent = data.shipping_rates.length > 1 ?
          `Se encontraron ${data.shipping_rates.length} tarifas de envío.` :
          "Se encontró 1 tarifa de envío.";
        formResults.classList.remove("d-none");
        formErrors.classList.add("d-none");
      } else {
        throw new Error("No se encontraron tarifas de envío.");
      }
    } catch (error) {
      // Mostrar errores
      errorMessage.textContent = error.message;
      formErrors.classList.remove("d-none");
      formResults.classList.add("d-none");
    } finally {
      // Restablecer estado del formulario
      formShipping.classList.remove("pending");
    }
  });
});